import type { FC } from "react";
import type React from "react";

import { abbrNumberFilter } from "app/filters/ngFilters";

import { StyledNewItemsListContainer, StyledNewListContent, StyledNewListItem } from "./styles";

interface INewItemsButtonProps {
    count: number;
    text: string;
    onClick: React.MouseEventHandler<HTMLDivElement>;
}

export const NewItemsButton: FC<INewItemsButtonProps> = ({ count, onClick, text }) => (
    <StyledNewItemsListContainer onClick={onClick}>
        <StyledNewListItem>{abbrNumberFilter()(count)}</StyledNewListItem>
        <StyledNewListContent>{text}</StyledNewListContent>
    </StyledNewItemsListContainer>
);
